<template>
  <div class="profile-picture-holder" :class="{ edit: mode === 'edit', 'loading-state': loading }">
    <span v-if="highRisk" class="photo-highrisk-badge" @click.prevent.stop title="High Risk" aria-label="High Risk">
      <sword-icon-wuk name="bolt" />
    </span>
    <span v-if="vip" class="photo-vip-badge" @click.prevent.stop title="VIP" aria-label="VIP">
      <sword-icon-wuk name="star-filled" />
    </span>
    <radius-container :side="side" :background="true" :border="border">
      <div v-if="loading" class="photo-placeholder loading">
        <sword-icon-wuk name="profile" :fill="false" />
      </div>
      <img
        v-else-if="!!picture || mode !== 'edit'"
        :src="imageSrc"
        :alt="$t('copy_2097')"
        @error="useFallback"
      />
      <template v-else-if="mode === 'edit'">
        <div v-if="!picture" class="photo-placeholder">
          <sword-icon-wuk name="profile" :fill="false" />
        </div>
        <div class="edit-photo">
          <sword-icon-wuk name="photo-camera" />
        </div>
      </template>
    </radius-container>
  </div>
</template>
<script>
import RadiusContainer from '@ui-kit/components/pictures/RadiusContainer.vue';
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'profilePicture',
  components: { RadiusContainer, SwordIconWuk },
  props: {
    vip: { type: Boolean, default: false },
    highRisk: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    side: { type: String, default: '100%' },
    maxSide: { type: String, default: 'none' },
    minSide: { type: String, default: 'none' },
    gender: { type: String, default: 'unknown' },
    picture: { type: String, default: null },
    mode: { type: String, default: 'read' },
    border: { type: Boolean, default: false },
  },
  data: () => ({
    defaultColoredBackground: false,
  }),
  computed: {
    imageSrc() {
      if (this.picture) {
        return this.picture;
      }

      return this.genderBasedAvatar;
    },
    genderBasedAvatar() {
      const pictureFolder = require.context('@ui-kit/assets/images/gender', true, /\.svg$/);
      try {
        return pictureFolder(`./${this.gender.toLowerCase()}-placeholder.svg`);
      } catch (error) {
        return pictureFolder('./unknown-placeholder.svg');
      }
    },
  },
  methods: {
    useFallback(error) {
      const { target } = error;
      if (!target || target.src === this.fallbackSrc) {
        console.log('Error loading fallback image', error);
        return;
      }

      target.src = this.genderBasedAvatar;
    },
  }
};
</script>
<style lang="scss" scoped>
.profile-picture-holder {
  position: relative;
  .photo-vip-badge, .photo-highrisk-badge {
    position: absolute;
    z-index: 2;
    background: $white;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    top: -0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;

    &::v-deep .sword-icon.svg-icon {
      width: calc($button-round-icon-base-size-wuk * 0.9);
      height: calc($button-round-icon-base-size-wuk * 0.9);
    }
  }
  .photo-vip-badge {
    right: -0.3rem;
    &::v-deep .sword-icon.svg-icon {
      fill: $yellow-wuk;
    }
  }
  .photo-highrisk-badge {
    left: -0.3rem;
    &::v-deep .sword-icon.svg-icon {
      fill: $hard-red;
    }
  }
}

.radius-comp-wrapper {
  position: relative;

  &.-border {
    border: solid 1px $context-color-6;
  }

  &.-default-background {
    background: $context-color-7;
  }
}


.photo-placeholder {
  width: calc(100% - #{map-get($sh-spacers-wuk, 1) * 2});
  height: calc(100% - #{map-get($sh-spacers-wuk, 1) * 2});
  @extend %-mxy_1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: $context-color-5;

  & > svg {
    z-index: 1;
    width: 40%;
    height: 40%;
  }
}


.loading-state {
  animation: fading 1.4s ease-in-out infinite;
}


.edit {
  max-width: max-content;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  .photo-placeholder {
    border: 1px dashed $context-color-6;

    & > svg {
      z-index: 1;
      width: 30%;
      height: 30%;
    }
  }

  .radius-comp-wrapper.-default-background {
    background: $context-color-8;
  }

  .edit-photo {
    display: none;
  }

  &:hover {
    .edit-photo {
      cursor: pointer;
      position: absolute;
      height: 40%;
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;

      & > svg {
        z-index: 1;
        width: 45%;
        height: 45%;
      }

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: $context-color-1;
        opacity: 0.7;
      }
    }
  }
}

.content-holder {
  @extend %square-container;
  img {
    object-fit: cover;
    object-position: center;
    height: 100%;
  }
}
</style>
